const genders = [
  { value: "M", label: "Masculino" },
  { value: "F", label: "Feminino" },
];

export const getGenderFromValue = (value) => {
  const res = genders.find((gender) => value === gender.value);
  return res;
};

export default genders;
